export default {
  login: {
    title: "Log in to start a session",
    email: "Email address",
    password: "Password",
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    register: "Sign up",
    connect: "Login",
    loading: "Loading..."
  },
  forgotPassword: {
    title: "Reset your password",
    backToLogin: "Back to login",
    notify:{
      successTitle: "Reset email sent",
      successText: "Check your emails"
    }
  },
  projectChooseLogin: {
    title: "Choose a project to log in",
    notify:{
      successText:"Redirect to the home page",
    }
  },
  resetPasswordForm: {
    title: "Set your new password",
    newPassword: "New password",
    backToLogin: "Back to login",
    confirmPassword: "Confirm password",
    errorPswRewritten:"The passwords do not match.",
    notify:{
      successResetText:"Password changed. You can now log in.",
      errorResetText:"An error has occurred"
    }
  },
  userRegister: {
    title: "Create an account to join a project",
    firstName: "First name",
    name: "Last name",
    email: "Email address",
    password: "Password",
    confirmPassword: "Confirm password",
    inscription: "Sign up",
    backToLogin: "Back to login",
    notify:{
      errorPswTitle:"Register Fail",
      errorPswText:"Password must be between 8 and 30 characters, with at least one uppercase letter, one lowercase letter, and one number et un caractère spécial.",
      errorPswTitle2: "Register Fail",
      errorPswText2Form:"Invalid form",
      errorPswText2Email:"Invalid email",
      successText:"Log in",
    }
  },
};
